import { LOGIN_ERROR_CODES } from "shared/config/authConstants";

/**
 * Prefix error codes for error messages related to self-signed deeplinks.
 */
export const LOGIN_SELF_SIGNED_DEEP_LINKS_ERROR_CODES = [
  LOGIN_ERROR_CODES.expired,
  LOGIN_ERROR_CODES.accountDisabled,
];
